// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"LoadingView_loadingWrapper__4lbuM"};